import React from "react";
import { Flex } from "../../../layouts/wrappers";
import { Button } from "../../../general/Button";
import { Heart, ThumbsUp, Smile } from "lucide-react";

interface ReactionBarProps {
  likes?: number;
  claps?: number;
  smiles?: number;
  onLike?: () => void;
  onClap?: () => void;
  onSmile?: () => void;
}

export const ReactionBar = ({
  likes = 0,
  claps = 0,
  smiles = 0,
  onLike,
  onClap,
  onSmile,
}: ReactionBarProps) => (
  <Flex direction="row" gap="sm" align="center">
    <Button variant="ghost" size="small" onClick={onLike}>
      <Heart size={16} /> {likes}
    </Button>
    <Button variant="ghost" size="small" onClick={onClap}>
      <ThumbsUp size={16} /> {claps}
    </Button>
    <Button variant="ghost" size="small" onClick={onSmile}>
      <Smile size={16} /> {smiles}
    </Button>
  </Flex>
);